import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import HowItWorks from '../components/HowItWorks';
import TopMovers from '../components/TopMovers';
import Services from '../components/Services';
import LiveActivity from '../components/LiveActivity';
import Testimonials from '../components/Testimonials';
import CoverageSection from '../components/CoverageSection';
import BlogPreview from '../components/BlogPreview';
import FAQ from '../components/FAQ';
import CTA from '../components/CTA';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location.hash]);

  return (
    <div>
      <Helmet>
        <title>MyMoveAdvisor | Compare Free Moving Quotes from Verified Local Movers</title>
        <meta name="description" content="Get free moving quotes from licensed, insured movers in minutes. Compare verified residential, commercial, and long-distance moving companies near you. No spam, no obligation." />
        <meta name="keywords" content="moving quotes, local movers, moving companies near me, free moving estimate, long distance movers, residential movers, commercial movers, licensed movers, insured movers, apartment movers, office movers, interstate movers, moving cost calculator, hire professional movers, best moving companies" />
        <link rel="canonical" href="https://mymoveadvisor.com/" />
        <meta property="og:title" content="MyMoveAdvisor | Free Moving Quotes from Verified Local Movers" />
        <meta property="og:description" content="Compare free quotes from licensed, insured movers near you. Residential, commercial, and long-distance moves covered in all 50 states." />
        <meta property="og:url" content="https://mymoveadvisor.com/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="MyMoveAdvisor | Free Quotes from Verified Movers" />
        <meta name="twitter:description" content="Compare free quotes from licensed, insured movers near you. Fast, easy, and 100% free." />
      </Helmet>
      <Hero />
      <TrustBar />
      <HowItWorks />
      <TopMovers />
      <Services />
      <LiveActivity />
      <Testimonials />
      <CoverageSection />
      <BlogPreview />
      <FAQ />
      <CTA />
    </div>
  );
};

export default Home;
